<div class="search">
  <dds-search enableSpellcheck
              [placeholder]="placeholder"
              [isTrimValue]="true"
              [isInverse]="true"
              customClass="article-search"
              size="lg"
              (valueChanged)="search($event)"
              #searchComponent></dds-search>

  @if (!isLoading && searchResultsList?.length) {
    <div class="search-popup">
        @for (category of searchResultsList; track category) {
        <strong class="search-popup__category">{{category.categoryName}}</strong>
        <div class="search-popup__list">
          @for(subCategory of category.subCategories; track subCategory) {
          <a class="search-popup__article"
            [routerLink]="['codedetails/', subCategory.codeId]"
            [innerHTML]="subCategory.subCategoryName | highlight: searchValue"
            (click)="searchComponent.clearField($event)"></a>
          }
        </div>
        }
      </div>
    }
    @else if(isLoading) {
      <div class="search-popup">
         <div class="skeleton-category">
            <div class="skeleton-title"></div>
             @for(i of [].constructor(3); track i) {
               <div class="skeleton-subcategory"></div>
             }
          </div>
      </div>
    }
    @else if(noResultsFound) {
      <div class="search-popup">
        <div class="no-results-found">No search results found</div>
      </div>
    }
</div>
